export enum GridType {
  Tenants = 'Tenants.query',
  Settings = 'Tenants.query',
  Adresses = 'Addresses.query',
  CellContainers = 'Containers.queryCells',
  Totes = 'Containers.queryTotes',
  Printers = 'Printers.query',
  Trolleys = 'Vehicles.query',
  StocksCurrentStatus = 'InventoryItems.query',
  StocksStockStatus = 'InventoryItems.queryStockItems',
  StocksWaitingToPutAway = 'InventoryItems.queryPutAwayAwaitingReceivedItems',
  StocksNoStock = 'InventoryItems.queryOutOfStockItems',
  Products = 'Products.query',
  MasterCartons = 'MasterCartons.query',
  ProductsByAllStock = 'Products.queryInventoryItemsByProduct',
  ProductsByProductDefinition = 'Products.queryProductListings',
  Operations = 'Operations.query',
  Workflows = 'Workflows.query',
  SalesOrdersCreatedList = 'SalesOrders.queryCreatedOrders',
  SalesOrdersPickingList = 'SalesOrders.queryOrdersInPicking',
  SalesOrdersPackingList = 'SalesOrders.queryOrdersInPacking',
  SalesOrdersDispatchList = 'SalesOrders.queryOrdersInDispatch',
  SalesOrdersDeliveredList = 'SalesOrders.queryDeliveredOrders',
  SalesOrdersSLAMList = 'SalesOrders.queryOrdersInSLAM',
  SalesOrdersCancelledList = 'SalesOrders.queryCancelledOrders',
  SalesOrderQueryLineItems = 'SalesOrders.queryLineItems',
  OrderTrackingPendingOrders = 'SalesOrders.queryOrderTrackingPendingOrders',
  ArrivedReturnPackagesList = 'Return.queryArrivedReturnPackages',
  InProcessReturnPackagesList = 'Return.queryInProcessReturnPackages',
  ResolvedReturnPackagesList = 'Return.queryResolvedReturnPackages',
  UndefinedReturnPackagesList = 'Return.queryUndefinedReturnPackages',
  ReceivingWaybills = 'Waybills.queryByPurchaseOrder',
  ReceivingPurchaseOrders = 'PurchaseOrders.query',
  ReceivingPurchasePackages = 'ReceivingProcesses.queryActiveInboundBoxes',
  ActiveReceivingPurchaseOrders = 'WebReceivingProcesses.queryActiveWebReceivingProcess',
  ReceivingPurchaseOrdersByOperation = 'PurchaseOrders.queryByOperation',
  ReceivingProducts = 'PurchaseOrders.queryLineItemsByPurchaseOrder',
  ReceivingLotNumbers = 'PurchaseOrders.queryLineItemLotNumbers',
  ReceivingWaybillHistory = 'HistoryManagement.getReceivingProcessRecordsByWaybillId',
  QuarantineToStock = 'QuarantineManagement.queryReceivedItemTotes',
  QuarantineDamaged = 'QuarantineManagement.queryDamagedItemTotes',
  QuarantineOutbound = 'QuarantineManagement.queryOutboundItemTotes',
  LostItems = 'InventoryItems.queryLostItemLogRecords',
  ReturnManagement = 'Return.queryReturnPackages',
  ReturnQueryLineItems = 'Return.queryLineItems',
  DispatchHistory = 'DispatchProcess.queryDispatchHistory',
  DispatchSalesOrders = 'DispatchProcess.querySalesOrdersByDispatchProcessId',
  DispatchCargoPackages = 'DispatchProcess.queryCargoPackagesByDispatchProcessId',
  DispatchManagement = 'DispatchProcess.query',
  PickingManagementActivePickings = 'PickingProcess.queryActivePickingProcesses',
  PickingManagementDropArea = 'PickingProcess.queryDropAddressedPickingTotes',
  PickingManagementPackingArea = 'PackingProcesses.queryPickingTrolleysInPacking',
  PickingTrolleyPickingTotes = 'Vehicles.queryPickingTrolleyPickingTotes',
  PickingManagementParkingArea = 'PickingProcess.queryAvailablePickingTrolleys',
  PickingManagementWaitingOrdersGrid = 'PickingProcess.queryWaitingForPickingSalesOrders',
  ReplenishmentJobs = 'ReplenishmentJobs.query',
  ReplenishmentNeeds = 'ReplenishmentJobs.needs',
  PickingManagementQuarantineTotes = 'PickingProcess.queryPickingQuarantineTotes',
  SalesOrderProblemsGrid = 'SalesOrders.queryProblems',
  SalesOrderOperationalStateDetails = 'SalesOrders.queryOperationalStateDetails',
  PickingProblemsGrid = 'Problems.queryPickingProblems',
  DispatchProblemsGrid = 'Problems.queryDispatchProblems',
  WallInventoryGrid = 'MissingItemTransferProcesses.queryWallInventoryItems',
  StocksZoneStatusGrid = 'InventoryItems.queryByZone',
  ZonesGrid = 'Zones.query',
  ZoneDetailsAddressesGrid = 'Zones.queryAdresses',
  ZoneDetailsProductsGrid = 'Zones.queryProducts',
  InboundProblemsGrid = 'InboundProblems.query',
  SalesOrderInboundProblemsGrid = 'InboundProblems.queryByPurchaseOrder',
  ReceivingOrdersPackagesGrid = 'InboundProblems.queryInboundBoxesByPurchaseOrder',
  WaybillDetailsProblemsGrid = 'InboundProblems.queryByWaybill',
  WaybillDetailsPackagesGrid = 'InboundProblems.queryInboundBoxesByWaybill',
  StockCountingTasksGrid = 'StockCountingTasks.getCellStockCountingTasksQuery',
  PickingListsGrid = 'PickingProcess.queryPickLists',
  PickListDetailsPickingPlan = 'PickingProcess.queryPickListPickingPlan',
  PickListDetailsPickingHistory = 'PickingProcess.queryPickListPickingHistory',
  PickListDetailsSalesOrders = 'PickingProcess.queryPickListSalesOrders',
  PickListItems = 'SalesOrders.queryPickListItems',
  FlowManagement = 'Vehicles.queryPickingTrolleySelectionConfigurations',
  PrioritizedSalesOrders = 'PickingProcess.queryPrioritizedSalesOrders',
  TransferTrolleys = 'TrolleyTransfers.queryActiveTransferTrolleys',
  TransferTrolleyPickingTotes = 'TrolleyTransfers.queryTransferTrolleyPickingTotes',
  PutAwayManagementWaitingProducts = 'InventoryItems.queryPutAwayReceivedItems',
  PutAwayManagementWaitingTotes = 'PutAway.queryWaitingTotes',
  PutAwayManagementActivePutAways = 'PutAway.queryActivePutAways',
  PutAwayManagementAvailablePutAwayTrolleys = 'PutAway.queryAvailablePutAwayTrolleys',
  PutAwayManagementCellStatus = 'Containers.queryStockCellStatus',
  PutAwayTrolleyTotes = 'Vehicles.queryPutAwayTrolleyTotes',
  PutAwayTotes = 'InventoryItems.queryPutAwayReceivedItemsByTote',
  SingleItemSalesOrdersToteDetails = 'PackingSingleItemProcesses.querySingleItemSalesOrdersToteDetails',
  SingleItemFastPackingToteDetails = 'PackingSingleItemFastPackProcesses.querySingleItemFastPackingToteDetails',
  SingleItemPickingToteDetails = 'PickingProcess.queryDropAddressedPickingToteDetails',
  CountingPlans = 'StockCountingTasks.queryStockCountingPlans',
  CountingPlanDetail = 'StockCountingTasks.queryStockCountingPlanItemsByPlanReferenceNumber',
  CreateCellStockCountingPlan = 'StockCountingTasks.queryToCreateCellStockCountingPlan',
  CreateItemStockCountingPlan = 'StockCountingTasks.queryToCreateItemStockCountingPlan',
  ReceivingOperations = 'PurchaseOrders.queryPurchaseOrderManagementCounts',
  InventoryTrolleys = 'Vehicles.queryTrolleyStatus',
  InventoryToteStatus = 'Containers.queryToteStatus',
  InventoryCellContainersGrid = 'Containers.queryStockCellStatus',
  InventoryTrolleyListDetailsGrid = 'Vehicles.queryTrolleyTotes',
  InventoryToteListDetailsGrid = 'InventoryItems.queryByContainerLabel',
  CountingLists = 'StockCountingTasks.queryStockCountingLists',
  ActiveCountings = 'StockCountingTasks.queryActiveStockCountingList',
  CountingListDetail = 'StockCountingTasks.queryStockCountingListDetails',
  SalesOrdersProductDetail = 'SalesOrders.querySalesOrderByProduct',
  PurchaseOrdersProductDetail = 'PurchaseOrders.queryPurchaseOrderByProduct',
  SystemCountings = 'StockCountingTasks.queryAutomaticStockCountingTasks',
  GetReceivingToteDetails = 'WebReceivingProcesses.getReceivingToteDetails',
  GetQuarantineToteDetails = 'WebReceivingProcesses.getQuarantineToteDetails',
  ManualCountings = 'StockCountingTasks.queryManualStockCountingTasks',
  CountingFlowManagement = 'StockCountingTasks.queryStockCountingListConfigurations',
  InventoryCellCountings = 'StockCountingTasks.queryStockCountingTasksByCellLabel',
  VasItems = 'SalesOrders.querySalesOrderVas',
  MarketPlaceSalesOrders = 'SalesOrders.queryMarketPlaceSalesOrders',
  DispatchPackages = 'DispatchProcess.queryCargoPackages',
  ProductReturnPackageDetails = 'Products.queryProductReturnPackageDetails',
  ProductStockCountingLists = 'Products.queryProductStockCountingLists',
  ReservedProductManagementBlockerFeeds = 'PutAway.queryReservedProductManagementBlockerFeeds',
  ReservedProductManagementReservedProducts = 'PutAway.queryReservedProductManagementReservedProducts',
  ReservedProductManagementProposedFeeds = 'PutAway.queryReservedProductManagementProposedFeeds',
  QualityCountings = 'StockCountingTasks.queryQualityStockCountingTasks',
  ExpirationDateTrackings = 'InventoryItems.queryInventoryItemExpirationDateTrackings',
  ReceivingPurchaseWaybills = 'Waybills.queryWaybills',
  PackageGridDetails = 'ReceivingProcesses.queryInboundBoxRecords',
  PickListExpectedItemsByCellLabel = 'PickingProcess.queryPickListExpectedItemsByCellLabel',
  InventoryItemsByProductWithSerialNumber = 'InventoryItems.queryInventoryItemsByProductWithSerialNumber',
  SerialNumberTrack = 'InventoryItems.queryInventoryItemSerialNumberTrackings',
  SimpleSerialNumberTrack = 'SalesOrders.querySalesOrderSerialNumberTrackings',
  ManualPicklists = 'ManualPicklists.queryWaitingForPickingSalesOrders',
  PickListRequests = 'PickListRequests.queryPickListRequests',
  PickListRequestSalesOrderDetails = 'PickListRequests.queryPickListRequestSalesOrderDetails',
  PickListRequestPickListDetails = 'PickListRequests.queryPickListRequestPickListDetails',
  WaitingPallets = 'Pallets.queryWaitingPallets',
  PutAwayReceivedItemsByPallet = 'InventoryItems.queryPutAwayReceivedItemsByPallet',
  WallToWallStockCountingTasksQueryCells = 'WallToWallStockCountingTasks.queryCells',
  PreviewWallToWallStockCountingPlanLists = 'WallToWallStockCountingTasks.previewWallToWallStockCountingPlanLists',
  PreviewWallToWallStockCountingPlanItems = 'WallToWallStockCountingTasks.previewWallToWallStockCountingPlanItems',
  QueryWallToWallStockCountingLists = 'WallToWallStockCountingTasks.queryWallToWallStockCountingLists',
  QueryWallToWallStockCountingAddresses = 'WallToWallStockCountingTasks.queryWallToWallStockCountingAddresses',
  QueryWallToWallStockCountingDamagedItems = 'WallToWallStockCountingTasks.queryWallToWallStockCountingDamagedItems',
  QueryWallToWallStockCountingProducts = 'WallToWallStockCountingTasks.queryWallToWallStockCountingProducts',
  GetListsWithIncorrectCountedCells = 'WallToWallStockCountingTasks.getListsWithIncorrectCountedCells',
  GetCellsForControlCount = 'WallToWallStockCountingTasks.getCellsForControlCount',
  QueryWallToWallStockCountingOperationsReport = 'WallToWallStockCountingTasks.queryWallToWallStockCountingOperationsReport',
  QueryWallToWallStockCountingAddressesReport = 'WallToWallStockCountingTasks.queryWallToWallStockCountingAddressesReport',
  QueryWallToWallStockCountingAddressProductsReport = 'WallToWallStockCountingTasks.queryWallToWallStockCountingAddressProductsReport',
  QueryWallToWallStockCountingProductsReport = 'WallToWallStockCountingTasks.queryWallToWallStockCountingProductsReport',
  QueryWallToWallStockCountingListsReport = 'WallToWallStockCountingTasks.queryWallToWallStockCountingListsReport',
  QueryWallToWallStockCountingDamagedItemsReport = 'WallToWallStockCountingTasks.queryWallToWallStockCountingDamagedItemsReport',
  QueryShippingItemsByProduct = 'Products.queryShippingItemsByProduct',
  QuerySalesOrdersWithPickListProblems = 'SalesOrders.querySalesOrdersWithPickListProblems',
  QueryStockZonePickListCapacity = 'Zones.queryStockZonePickListCapacity',
  ApprovedCargoPackagesGrid = 'SLAM.queryWaitingForSLAMApprovedCargoPackages',
  ProblemSolverQueryMissingOrders = 'ProblemSolver.queryMissingOrders',
  ProblemSolverQueryMissingOrderDetails = 'ProblemSolver.queryMissingOrderDetails',
  ProblemSolverQueryMissingNotifications = 'ProblemSolver.queryMissingNotifications',
  ProblemSolverQueryRasMissingNotifications = 'ProblemSolver.queryRasMissingNotifications',
  ProblemSolverQueryRasMissingNotificationsByFace = 'ProblemSolver.queryRasMissingNotificationsByFace',
  ProblemSolverQueryPendingCancellationsByCell = 'ProblemSolver.queryPendingCancellationsByCell',
}
